import React from 'react'
import { Link } from 'react-router-dom'

export type ExternalLinkProps = React.PropsWithChildren<{
  to: string
}>

export const ExternalLink = ({
  to,
  children,
}: ExternalLinkProps): JSX.Element => {
  return (
    <Link target="_blank" rel="noreferrer" to={to}>
      {children}
    </Link>
  )
}
